import logoUrl from "../assets/harvust-logo-008.svg";
import logoMiniUrl from "../assets/harvust-logo-006.svg";
import frameTemplate from "./frame.html";
import navDropdownTemplate from "./nav_dropdown.html";
import genericNavDropdownTemplate from "./generic_nav_dropdown.html";
import mixpanel from "mixpanel-browser";
import _ from "lodash";

class NavDropDownController {
    /* @ngInject */
    constructor($document, $element, $timeout, AuthService) {
        this.AuthService = AuthService;
        this.$document = $document;
        this.$element = $element;
        this.$timeout = $timeout;
        this.expanded = false;
        let ctrl = this;
        ctrl.$document.on("click", function (event) {
            if (ctrl.expanded) {
                ctrl.$timeout(function () {
                    let contents = ctrl.$element.find("*");
                    ctrl.expanded = Array.from(contents).includes(event.target);
                });
            }
        });
    }

    logout() {
        let ctrl = this;
        mixpanel.track("Clicked sign out");
        ctrl.AuthService.logout();
    }
}
export const NavDropdownComponent = {
    controller: NavDropDownController,
    bindings: { account: "<" },
    template: navDropdownTemplate,
};

class GenericNavDropDownController {
    /* @ngInject */
    constructor($document, $element, $timeout, $state, $transitions) {
        this.$document = $document;
        this.$element = $element;
        this.$timeout = $timeout;
        this.$state = $state;
        this.expanded = false;
        let ctrl = this;
        ctrl.$document.on("click", function (event) {
            if (ctrl.expanded) {
                ctrl.$timeout(function () {
                    let contents = ctrl.$element.find("*");
                    ctrl.expanded = Array.from(contents).includes(event.target);
                });
            }
        });

        $transitions.onFinish({}, function (transition) {
            ctrl.currentState = transition.to().name;
            ctrl.currentStateParams = transition.params("to");
            ctrl.showSpinner = false;
        });
    }

    $onInit() {
        let ctrl = this;
        ctrl.currentState = ctrl.$state.current.name;
        ctrl.currentStateParams = ctrl.$state.params;
    }

    getNavLabel(state) {
        let ctrl = this;
        for (let navOption of ctrl.navOptions) {
            if (ctrl.$state.includes(navOption.state)) {
                return navOption.label;
            }
        }
    }

    navigate(state) {
        let ctrl = this;
        ctrl.expanded = false;
        ctrl.showSpinner = true;
    }
}
export const GenericNavDropdownComponent = {
    controller: GenericNavDropDownController,
    bindings: { navOptions: "<" },
    template: genericNavDropdownTemplate,
};

class GlobalController {
    /* @ngInject */
    constructor(AuthService, $rootScope, $window, VersionCheckerService) {
        let ctrl = this;
        this.LOGO_URL = logoUrl;
        this.MINI_LOGO_URL = logoMiniUrl;
        this.AuthService = AuthService;
        this.$rootScope = $rootScope;
        this.$window = $window;
        this.VersionCheckerService = VersionCheckerService;
        this.showRefreshBanner = false;
        ctrl.showWorkerLoginBanner =
            $window.location.hostname === "worker.harvust.com";

        ctrl.stopVersionChecker = ctrl.VersionCheckerService.start({
            onUpdateAvailable: function () {
                ctrl.showRefreshBanner = true;
            },
        });
    }

    logout() {
        let ctrl = this;
        mixpanel.track("Clicked sign out");
        ctrl.AuthService.logout();
    }

    reloadApp() {
        let ctrl = this;
        ctrl.$window.location.reload();
    }

    dismissRefreshBanner() {
        let ctrl = this;
        ctrl.showRefreshBanner = false;
    }

    $onDestroy() {
        let ctrl = this;
        console.log("[GlobalController] $onDestroy", {
            hasStopVersionChecker: !!ctrl.stopVersionChecker,
        });
        if (ctrl.stopVersionChecker) {
            ctrl.stopVersionChecker();
        }
    }
}

export const FrameComponent = {
    controller: GlobalController,
    bindings: { account: "<" },
    template: frameTemplate,
};
